// ABOUTME: SPEC-46 Rev 7 — the checkout panel's own dimensions, in the reel's authored units.
// ABOUTME: waitlistGeometry.js's shape: numbers only, so the panel file stays about behaviour.

// Wider than the waitlist panel: Stripe renders its own card form inside, and squeezing it
// below this makes the expiry/CVC row wrap awkwardly on desktop.
export const PANEL_W_PX = 460;
// How long we wait for Stripe.js to load AND the session to initialise before telling the
// guest it failed. Neither Stripe call carries its own timeout, and a promise that never
// settles is indistinguishable from a slow one to anyone staring at a spinner.
export const LOAD_TIMEOUT_MS = 12000;

// The mount node deliberately has NO height of its own. Stripe's iframe measures itself and
// grows; giving the container a fixed height is the classic embedded-checkout bug — the pay
// button ends up below the fold with nothing to scroll.
export const MOUNT_MIN_H_PX = 320;

// How long "Payment received" stays up before the panel closes itself, matching the waitlist
// confirmation's own dwell so the two read as one house.
export const COMPLETE_DWELL_MS = 2400;

export const CLOSE_BOX_PX = 40;
export const CLOSE_GLYPH_PX = 18;
